<template>
    <Correction></Correction>
</template>
<script>
import Correction from '@/components/gis/siteCorrection';
export default {
    name: 'baseInfo',
    components: {
        Correction
    }
};
</script>